import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import { Auth } from './page/Auth';
import Game from './page/game/Game';
import { useCallback, useEffect, useState } from 'react';
import { connectSocket, disconnectSocket } from './helper/socket';
import { imagesKeyToPreloadInApp, imagesToPreloadInApp, preloadImages } from './utills/preloadAssets';
import { useGameSettings } from './components/slotGame/slotData';
import Unauthorized from './page/Unauthorized';
import ConnectionLost from './page/ConnectionLost';
import { resetPlaceBet } from './redux/slices/placeBetSlice';
import { resetFreeSpin } from './redux/slices/freeSpinSlice';
import { useDispatch } from 'react-redux';

function App() {
  const navigate = useNavigate();
  const [isPortrait, setIsPortrait] = useState(window.innerWidth < window.innerHeight);
  const [isOnline, setIsOnline] = useState(true)
  const [appAssetsLoaded, setAppAssetsLoaded] = useState(false)
  const gameSettings = useGameSettings();
  const dispatch = useDispatch();

  useEffect(() => {
    const imagesFromKeys = imagesKeyToPreloadInApp
      .map((key) => gameSettings[key])
      .filter(Boolean);

    preloadImages([...imagesFromKeys, ...imagesToPreloadInApp])
      .then(() => {
        setAppAssetsLoaded(true)
        console.log("✅ Images preloaded");
      })
      .catch((err) => {
        console.error("❌ Error preloading images:", err);
      });
  }, [gameSettings]);

  useEffect(() => {
    function checkOrientation() {
      setIsPortrait(window.innerWidth < 768 && window.matchMedia("(orientation: portrait)").matches);
    }

    window.addEventListener("resize", checkOrientation);
    checkOrientation();

    return () => {
      window.removeEventListener("resize", checkOrientation);
    };
  }, []);

  const unauthorized = useCallback(() => {
    navigate('/unauthorized');
  }, [navigate])

  const connectionLost = useCallback(() => {
    navigate('/connection-lost');
  }, [navigate])

  const onConnection = useCallback(() => {
    if (isOnline) {
      navigate("/game");
    }
  }, [isOnline, navigate])

  useEffect(() => {
    connectSocket(unauthorized, connectionLost, onConnection);
  }, [connectionLost, onConnection, unauthorized])

  useEffect(() => {
    if (!navigator.onLine) {
      setIsOnline(false);
      disconnectSocket();
      navigate('/connection-lost');
    }
  }, [navigate]);
  
  useEffect(() => {
    const handleOnline = () => {
      connectSocket(unauthorized, connectionLost, onConnection);
      dispatch(resetPlaceBet());
      dispatch(resetFreeSpin());
      setIsOnline(true)
      window.location.href = '/game';
    };

    const handleOffline = () => {
      disconnectSocket();
      setIsOnline(false)
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      disconnectSocket(); // cleanup
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());
    return () => document.removeEventListener("contextmenu", (e) => e.preventDefault());
  }, []);

  return (
    <div className="App">
      {/* Device rotation warning */}
      {isPortrait && (
        <div className="rotate-message">
          <h2>Please rotate your device to play the game.</h2>
        </div>
      )}

      {/* Main game/router content */}
      <div className="rotated-container">
        <Routes>
          <Route path="/" element={<Navigate to="/launch" />} />
          <Route path="/launch" element={<Auth />} />
          <Route path="/game" element={<Game appAssetsLoaded={appAssetsLoaded} />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/connection-lost" element={<ConnectionLost />} />
          {/* Optional fallback for unknown routes */}
          <Route path="*" element={<Navigate to="/launch" />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
